import React, { useEffect, useRef, useState } from 'react';
import { Instagram, Flame } from 'lucide-react';
import './CallToAction.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/drx2byx3_Logo%20DTC.png';
const QR_URL = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://www.instagram.com/dogoseltiochepe&color=D4AF37&bgcolor=0D0D0D&format=png';

export const CallToAction = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta" ref={ref} data-testid="cta-section">
      <div className="cta-fire-top" />
      <div className="cta-container">
        <div className={`cta-content ${visible ? 'vis' : ''}`}>
          <img src={LOGO_URL} alt="Dogos El Tío Chepe" className="cta-logo" />
          <h2 className="cta-title">
            <Flame size={28} className="cta-flame-icon" />
            Tu antojo te espera
          </h2>
          <p className="cta-desc">
            Pasa por tu dogo favorito este fin de semana. Te prometemos que no podrás comer solo uno.
          </p>
          <a href="#ubicacion" className="cta-btn" data-testid="cta-visit-btn">
            Visítanos en Tapalpa
          </a>
        </div>

        <div className={`cta-qr-block ${visible ? 'vis' : ''}`} data-testid="cta-qr-section">
          <div className="cta-qr-frame">
            <img src={QR_URL} alt="QR Code Instagram" className="cta-qr-img" data-testid="qr-code-img" />
          </div>
          <p className="cta-qr-label">Escanea para seguirnos</p>
          <a
            href="https://www.instagram.com/dogoseltiochepe"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-instagram-btn"
            data-testid="cta-instagram-btn"
          >
            <Instagram size={18} />
            @dogoseltiochepe
          </a>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
